import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppStateService } from '../share/services/appstate.service';
import { SessionService } from '../share/services/session.service';

@Directive({
  selector: '[policy]',
  inputs: ['policy']
})
export class RolesDirective { 

  maingroupName: string; 

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private sessionService: SessionService,
    private appState: AppStateService
  ) {
    this.maingroupName = this.sessionService.getMaingroupName();
  }

  @Input() set policy(policy: Array<string>) { 
    let shouldShow: boolean = false; 

    for (let allowedPolicy of policy) {
      let policyGroups = this.appState.policies.get(allowedPolicy);
      if (policyGroups) {
        for (let policyGroup of policyGroups) {
          if (policyGroup.toUpperCase() == this.sessionService.getMaingroupName().toUpperCase()) { 
            shouldShow = true;
            break;
          }
        }
      }
    }
    if (shouldShow) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
